module.exports = __webpack_public_path__ + "img/saved-filled.85f35c3c.svg";